
export const BASEURL = 'https://stock-menager-back-end.onrender.com' 

//  https://stock-menager-back-end.onrender.com
// http://localhost:4000
